import type { TFunction } from 'i18next';
import { estEchecConnecteur, raisonConnecteur } from '../../../../lib/connecteurs.js';
import { messageReprise } from '../../../tabs/reprise/messages.js';

/**
 * Le message d'une erreur du connecteur, ou `null` quand il n'y a rien à dire
 * (la personne a fermé la boîte du second facteur). Les raisons nommées du
 * connecteur ont leur phrase ; `mandat_absent` et `nature_hors_mandat` sont
 * celles de la reprise ; le reste garde la phrase de l'API.
 */
export function messageConnecteur(t: TFunction, erreur: unknown): string | null {
  const raison = raisonConnecteur(erreur);
  if (raison !== null) return String(t(`importDropbox.erreurs.${raison}`));
  if (estEchecConnecteur(erreur)) return String(t('importDropbox.erreurs.echec'));
  return messageReprise(t, erreur);
}
